'use strict';

module.exports = function IntentProcessor(navigatorShim, pageController, copyFileController) {
	if (!navigatorShim || !pageController || !copyFileController) {
		throw new Error('invalid-args');
	}
	const allowedIntents = ['trashFile', 'untrashFile', 'copyFile'],
		intent = navigatorShim.getQueryStringAsMap().intent;
	let intentFunction;
	if (!intent || !allowedIntents.includes(intent)) {
		return;
	}
	if (intent === 'copyFile') {
		intentFunction = copyFileController.start;
	} else {
		intentFunction = pageController[intent];
	}

	if (intentFunction) {
		pageController.addEventListener('goldFileLoadComplete', intentFunction);
	}
};
